import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import uniqueId from 'lodash/uniqueId';

import { Typo } from 'uikit/content';
import FormFieldContainer from '../containers/formFieldContainer';
import FormDecoration from './formDecoration';

const Form = ({ title, variant, model, schema, form, state, onUpdateField, isDisabled }) => {
  function renderTitle() {
    if (!title) return null;
    return <Typo element="h2">{title}</Typo>;
  }

  function renderFields() {
    return map(schema, (schemaValue, schemaKey) => {
      const { type, label, help, className, isDecoration } = schemaValue;
      const fieldId = `${uniqueId('form-field-')}-${type.toLowerCase()}`;
      const value = model[schemaKey];
      const fieldState = state[schemaKey] || {};

      if (fieldState.shouldHideField) return null;

      if (isDecoration) {
        return (
          <FormDecoration
            model={model}
            variant={variant}
            key={schemaKey}
            schema={schemaValue}
            type={type}
            className={className}
            form={form}
            fieldId={fieldId}
            fieldKey={schemaKey}
          />
        );
      }

      return (
        <FormFieldContainer
          variant={variant}
          model={model}
          key={schemaKey}
          value={value}
          type={type}
          label={label}
          help={help}
          className={className}
          form={form}
          fieldId={fieldId}
          fieldKey={schemaKey}
          isDirty={fieldState.isDirty}
          hasError={fieldState.hasError}
          error={fieldState.error}
          hasCondition={fieldState.hasCondition}
          condition={fieldState.condition}
          schema={schemaValue}
          onUpdateField={onUpdateField}
          isRequired={fieldState.isRequired}
          isFormDisabled={isDisabled}
        />
      );
    });
  }

  return (
    <div>
      {renderTitle()}
      {renderFields()}
    </div>
  );
};

Form.defaultProps = {
  title: '',
  variant: 'default',
  state: {},
  onUpdateField: () => {},
  isDisabled: false,
};

Form.propTypes = {
  title: PropTypes.string,
  variant: PropTypes.string,
  model: PropTypes.shape({}).isRequired,
  schema: PropTypes.shape({}).isRequired,
  form: PropTypes.shape({}).isRequired,
  state: PropTypes.objectOf(
    PropTypes.shape({
      isDirty: PropTypes.bool,
      hasError: PropTypes.bool,
      error: PropTypes.string,
      hasCondition: PropTypes.bool,
      condition: PropTypes.shape({}),
      shouldHideField: PropTypes.bool,
      isRequired: PropTypes.bool,
    }),
  ),
  onUpdateField: PropTypes.func,
  isDisabled: PropTypes.bool,
};

export default React.memo(Form);
